import State from 'interfaces/state/State';

export const uploadedTrack$ = (state: State): string | null => state.siteEvents.uploadedTrack;
export const listenedTrack$ = (state: State): string | null => state.siteEvents.listenedTrack;
export const listenedtrackStatistic$ = (state: State): string | null => state.siteEvents.listenedtrackStatistic;
export const isError$ = (state: State): boolean => state.siteEvents.isError;
export const isLoading$ = (state: State): boolean => state.siteEvents.isLoading;
